export const SIGN_IN_ROUTE = '/signin-app';
export const MAIN_ROUTE = '/main-app';
export const STATS_ROUTE = '/stats';
export const LECTION_ROUTE = '/lection';
export const WORKSPACE_ROUTE = '/workspace';
export const SIGN_IN_EMPTY_ROUTE = '/';
export const LENDING_ROUTE = '/lending';
export const PLAYER_ROUTE = '/player';
export const PLAYER_CONSPECT_ROUTE = '/player-conspect';
export const SIGN_IN_EMPTY_2_ROUTE = '/test-kazan';

export const PURCHASE_ROUTE = '/purchase';
export const INSTRUCTION_ROUTE = '/instruction';
export const CONFIRM_ROUTE = '/confirm';
export const SPPORT_ROUTE = '/support-app';
export const CONFIRM_CLOUD_PAY_ROUTE = '/confirm-cloud-pay';

export const PURCHASE_ROUTE_TEST = '/purchase-test-now-new';
export const AUTH_HELP = '/auth-help';
